import React from 'react'
import "../flash_deal/FlashDeal.css"
import { Col, Container, Row } from 'react-bootstrap'
const FlashDeal = () => {
  return (
    <>
     <section id="flash_deal">
      <Container>
        <h1>Flash Deals of the Week</h1>
        <Row style={{rowGap:'40px'}}>
          <Col lg={6}>
            <div class="flash_deal_manu">
              <div class="flash_deal_img">
                <img src="imeges/desktop 9/flash detels ovacodo.svg" class="w-100" alt=""/>
              </div>
              <div class="flash_deal_text">
              <div class="flash_deal_text_inner">
                <ul>
                  <li><h4>45 <br/>Days</h4></li>
                  <li><h4>45 <br/>Hour</h4></li>
                  <li><h4>45 <br/>Min</h4></li>
                  <li><h4>45 <br/>Sec</h4></li>
                </ul>
              </div>
                <h4>Diamond Halo Stud Earrings</h4>
                <ul class="icson">
                    <li><i class="fa-solid fa-star"></i></li>
                    <li><i class="fa-solid fa-star"></i></li>
                    <li><i class="fa-solid fa-star"></i></li>
                    <li><i class="fa-solid fa-star"></i></li>
                    <li><i class="fa-solid fa-star"></i></li>
                </ul>
                <p>$8.00-9.00</p>
                <a href="#"><button class="shop_now">Add to cart</button></a>
              </div>
            </div>
          </Col>
          <Col lg={6}>
            <div class="flash_deal_manu">
              <div class="flash_deal_img">
                <img src="imeges/desktop 9/flash detels licu.svg" class="w-100" alt=""/>
              </div>
              <div class="flash_deal_text">
              <div class="flash_deal_text_inner">
                <ul>
                  <li><h4>45 <br/>Days</h4></li>
                  <li><h4>45 <br/>Hour</h4></li>
                  <li><h4>45 <br/>Min</h4></li>
                  <li><h4>45 <br/>Sec</h4></li>
                </ul>
              </div>
                <h4>Diamond Halo Stud Earrings</h4>
                <ul class="icson">
                    <li><i class="fa-solid fa-star"></i></li>
                    <li><i class="fa-solid fa-star"></i></li>
                    <li><i class="fa-solid fa-star"></i></li>
                    <li><i class="fa-solid fa-star"></i></li>
                    <li><i class="fa-solid fa-star"></i></li>
                </ul>
                <p>$8.00-9.00</p>
                <a href="#"><button class="shop_now">Add to cart</button></a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
  </section>
    </>
  )
}

export default FlashDeal